import "./css/board.css";
import { NavLink, Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
//import Pagination from "./Pagination";
import SubHeader from "../components/subHeader4";

import Pagination from "./Pagination";
import qs from "qs";

import Cookies from "universal-cookie";
import styled from "styled-components";

import i18next from "../config/lang/i18next";

const StyledLink = styled(NavLink)`
width:20%;
cursor:pointer;
font-weight:bold;
color:rgb(126, 126, 126);
display: inline-block;
font-size:1.2rem;
border-right:1px solid gray;
`;
const cookies = new Cookies();

const Board = () => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const [isEmpty, setEmpty] = useState(false);
  const [isPage, setIsPage] = useState(false);

  const offset = (page - 1) * limit;
  const [data, setData] = useState([]);
  const [filterData, setfilterData] = useState([]);

  const [search, setSearch] = useState(null);
  const [options, setOption] = useState("subject");

  const [isloggedIn, setLoggedIn] = useState(false);

  const onChangeSearch = (e) => {
    //e.preventDefault();
    setSearch(e.target.value);
  };

  const selectHandle = (e) => {
    e.preventDefault();
    setOption(e.target.value);
  };
  /*const searchPosts = ({ page, option, content }) => {
        const queryString = qs.stringify({
          page,
          option,
          content
        });
        return axios.get(`/board/search?${queryString}`);
    }*/
  const onSearch = (e) => {
    e.preventDefault();

    /*
        axios.get('http://222.101.0.9:5000/boardlist').then((response)=> {
            setData(response.data);
            
        })
        alert(options);
        searchPosts({ page: page, option: options, content: search });
        setSearch('');*/
    console.log(search);
    console.log(data);
    if (options === "subject") {
      const filtered = data.filter((itemList) => {
        console.log(itemList);
        return itemList.subject.toUpperCase().includes(search.toUpperCase());
      });
      setfilterData(filtered);
      if (filtered.length === 0) {
        setEmpty(true);
      } else {
        setEmpty(false);
      }
    } else if (options === "content") {
      const filtered = data.filter((itemList) => {
        console.log(itemList);
        return itemList.content.toUpperCase().includes(search.toUpperCase());
      });
      setfilterData(filtered);
      if (filtered.length === 0) {
        setEmpty(true);
      } else {
        setEmpty(false);
      }
    }
  };

  function GetData() {
    useEffect(() => {
      axios.get("https://thegmmedical.com:5002/api/career").then((response) => {
        setData(response.data);
        setfilterData(response.data);
        if (response.data.length === 0) {
          setEmpty(true);
          console.log(response.data);
        } else {
          console.log("haha");
          setEmpty(false);
          if (response.data.length <= 10) {
            setIsPage(false);
          } else {
            setIsPage(true);
          }
        }
      });
      fetch("https://thegmmedical.com:5002/check", {
        method: "get", // 통신방법
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.message === "user존재") {
            setLoggedIn(true);
          }
        })
        .catch(() => {});
    }, []);

    const item = Object.values(data).map((item) => (
      <tr>
        <td className="m_dp_n">{item.board_id}</td>
        <td className="m_dp_n"></td>
        <td className="ta_l">
          <a className="bl_link" href="/career/view">
            {item.subject}
          </a>
        </td>
        <td>{item.board_date}</td>
      </tr>
    ));

    return item;
  }

  const item = GetData();

  const [ScrollY, setScrollY] = useState(0);
  const [BtnStatus, setBtnStatus] = useState(false); // 버튼 상태

  const handleFollow = () => {
    setScrollY(window.pageYOffset);
    if (ScrollY > 100) {
      // 100 이상이면 버튼이 보이게
      setBtnStatus(true);
    } else {
      // 100 이하면 버튼이 사라지게
      setBtnStatus(false);
    }
  };

  const handleTop = () => {
    // 클릭하면 스크롤이 위로 올라가는 함수
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setScrollY(0); // ScrollY 의 값을 초기화
    setBtnStatus(false); // BtnStatus의 값을 false로 바꿈 => 버튼 숨김
  };

  useEffect(() => {
    const watch = () => {
      window.addEventListener("scroll", handleFollow);
    };
    watch();
    return () => {
      window.removeEventListener("scroll", handleFollow);
    };
  });
  return (
    <div className="wrapper">
      <style>
        {`
        .board_list table td {
            padding: 20px 10px;
            height: auto;
            color: #444;
            position: relative;
        }
        .board_list table tr th:nth-of-type(2) {
            width: 80% !important;
            padding-left: 20px;
        }
        .board_list table tr th:nth-of-type(1) {
            width:10% !important;
        }
        .board_list table tr th:nth-of-type(3) {
            width:10% !important;
        }
        @media (max-width: 1180px){
            .board_list thead{
                border-bottom: 1px solid #ddd;
            }
        }
        @media (max-width: 860px) {
         .headerTxt{
            margin:50px 0 0;
         }
        .i-bat2{
            display:none;
        }
        }
        `}
      </style>
      <SubHeader />
      <h1 className="headerText">{i18next.t("navbar.4-2")}</h1>
      <div className="board_wrapper">
        <form name="form1" id="form1" method="post">
          {/*<input name="pageIndex" id="pageIndex" type="hidden" value={null || ''} />

          <input type="hidden" id="ncv_file_seq" name="ncv_file_seq" value={null || ''} />
          <input type="hidden" id="file_path" name="file_path" value={null || ''} />
          <input type="hidden" id="file_name" name="file_name" value={null || ''} />
          <input type="hidden" id="brdId" name="brdId" value={null || ''} />
          <input type="hidden" id="brdGubun" name="brdGubun" value={null || ''} />
          <input type="hidden" id="dataGubun" name="dataGubun" value={null || ''} />
          <input type="hidden" id="ncvContSeq" name="ncvContSeq" />*/}
<input name="pageIndex" id="pageIndex" type="hidden" value=""/>

<input type="hidden" id="ncv_file_seq" name="ncv_file_seq" value="" />
<input type="hidden" id="file_path" name="file_path" value="" />
<input type="hidden" id="file_name" name="file_name" value="" />
<input type="hidden" id="brdId" name="brdId" value="" />
<input type="hidden" id="brdGubun" name="brdGubun" value="" />
<input type="hidden" id="dataGubun" name="dataGubun" value="" />
<input type="hidden" id="ncvContSeq" name="ncvContSeq" />
          <div className="container">
            <div>
              <div id="content" className="content">
                <div>
                  <div className="sub_top">
                    <div className="st_navigation">
                      <ul></ul>
                    </div>
                  </div>

                  <div className="board_top" style={{display:"block", zIndex:"11000"}}>
                    <fieldset>
                      {/*<label>
                    페이지 당 게시물 수:&nbsp;
                    <select
                    type="number"
                    value={limit}
                    onChange={({ target: { value } }) => setLimit(Number(value))}
                    >
                    <option value="10">10</option>
                    <option value="12">12</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    </select>
                </label>*/}
                      <div className="bt_srch">
                        <div className="bts_slct">
                          <select
                            id="u_shcate"
                            name="search_item"
                            className="select"
                            title="검색항목 선택"
                            value={options}
                            onChange={selectHandle}
                          >
                            <option value="subject">{i18next.t("subject")}</option>
                            <option value="content">{i18next.t("content")}</option>
                          </select>
                        </div>
                        <div className="bt_input">
                          <input
                            type="text"
                            id="search_content"
                            name="search_content"
                            value={search}
                            placeholder={i18next.t("placeholder")}
                            onChange={onChangeSearch}
                          />
                        </div>

                        <button
                          type="submit"
                          className="search_btn"
                          value="검색"
                          onClick={onSearch}
                        >
                          {i18next.t("search")}
                        </button>
                      </div>
                    </fieldset>
                  </div>

                  <div className="board_list">
                    <table>
                      <colgroup>
                        <col className="m_dp_n table_no" />
                        <col className="ta_l" />
                        <col className="m_dp_n table_date" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th className="m_dp_n table_no" scope="col">
                            NO.
                          </th>
                          <th className="ta_l" scope="col"></th>
                          <th className="m_dp_n table_date" scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isEmpty && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={4}>게시물이 없습니다.</td>
                          </tr>
                        )}
                        {filterData
                          .slice(offset, offset + limit)
                          .map(({ board_id, subject, board_date }) => (
                            <tr key={board_id}>
                              <td className="m_dp_n">{board_id}</td>
                              <td
                                className="ta_l"
                                style={{ textAlign: "left" }}
                              >
                                <span className="i-bat2 ty1 mr20">NOTICE</span>
                                <Link to={`/career/view/${board_id}`}>
                                  {subject}
                                </Link>
                              </td>
                              <td>{board_date.substring(5, 10)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div style={{width:"100%",textAlign:"right"}}>
                    {isloggedIn && (
                      <Link to="write"
                        style={{
                          padding: "10px 30px",
                          marginTop: "20px",
                          backgroundColor: "#555",
                          color: "white",
                          textAlign: "center",
                          position:"relative",
                          display:"inline-block",
                          width:"105px",
                          cursor: "pointer",
                        }}
                      >
                        글쓰기
                      </Link>
                    )}
                    </div>
                  </div>
                  {isPage && (
                    <div className="paging">
                      <Pagination
                        postsPerPage={limit}
                        totalPosts={filterData.length}
                        page={page}
                        paginate={setPage}
                      ></Pagination>
                      {/*<Pagination
                    total={data.length}
                    limit={limit}
                    page={page}
                    setPage={setPage}
                    />*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Board;
